import React from "react"
import Img from "gatsby-image"

const ImageWithLabel = ({ label, fluidImage, imgAlt, imgTitle }) => {
  return (
    <div className="image-with-label">
      <Img
        fluid={fluidImage}
        alt={imgAlt}
        title={imgTitle}
        // style={{ maxWidth: fluidImage.presentationWidth }}
      ></Img>
      {label && <label dangerouslySetInnerHTML={{ __html: label }}></label>}
    </div>
  )
}

export default ImageWithLabel
